import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { FaSpinner } from "react-icons/fa";


interface CustomDialogProps {
  title: string;
  rejectLabel: string;
  confirmLabel: string;
  confirmDialog: () => void;
  rejectDialog: () => void;
  visible: boolean;
  disabled?: boolean
  loading?: boolean
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  title,
  rejectLabel,
  confirmLabel,
  confirmDialog,
  rejectDialog,
  visible,
  disabled,
  loading
}) => {
  const footer = (
    <div className="flex justify-center gap-1 py-4">
      <Button
        label={rejectLabel}
        onClick={rejectDialog}
        className="custom-reject-btn"
        disabled={disabled}
      />
      <Button
        label={confirmLabel}
        onClick={confirmDialog}
        className="custom-accept-btn"
        loading={loading}
        loadingIcon={<FaSpinner/>}
        disabled={disabled}
      />
    </div>
  );

  return (
    <Dialog
      header="Confirmation"
      visible={visible}
      footer={footer}
      onHide={rejectDialog}
    >
      <p>{title}</p>
    </Dialog>
  );
};

export default CustomDialog;
